<template>
  <div class="driver-vehicle-fields">
    <el-form-item label="司机姓名:" prop="driverId" class="width1" >
      <el-select v-model="addForm.driverId" filterable placeholder="请选择" @change="sijiChange">
        <el-option v-for="item in sijiList" :label="item.name" :value="item.id" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="司机电话:" prop="driverPhone" class="width1" >
      <el-input placeholder="" maxlength="50" v-model="addForm.driverPhone" :readonly="true"></el-input>
    </el-form-item>
    <el-form-item label="司机所属小队:" prop="teamCode" class="width1" >
      <el-select v-model="addForm.teamCode" filterable placeholder="请选择" clearable :disabled="true">
        <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="车头牌号:" prop="plateNumber" class="width1" >
      <el-select v-model="addForm.plateNumber" filterable placeholder="请选择" @change="carChange">
        <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="车辆所属小队:" prop="vehicleTeamCode" class="width1">
      <el-select v-model="addForm.vehicleTeamCode" filterable placeholder="请选择" clearable :disabled="true">
        <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="挂车牌号:" prop="trailerPlate" class="width1" v-if="isGuaChe">
      <el-input placeholder="" maxlength="50" v-model="addForm.trailerPlate" :readonly="true"></el-input>
    </el-form-item>
  </div>
</template>

<script>
import { cDlists, cVIlists } from '@/api/vgs-driver2.0'
export default {
  name: 'DriverVehicleFields',
  props: {
    // 父组件的 addForm 对象
    addForm: {
      type: Object,
      required: true,
      default: () => ({})
    },
    XDList: {
      type: Array,
      default: () => []
    },
    isGuaChe: {
      type: Boolean
    }
  },
  data () {
    return {
      sijiList: [],
      carList: []
    }
  },
  mounted () {
    cDlists({ driverClassify: 2, tenantId: localStorage.getItem('tenantCode') }).then(res => { this.sijiList = res })
    cVIlists({ vhcClassify: 2, trailerFlag: 0, tenantId: localStorage.getItem('tenantCode') }).then(res => {
      this.carList = res
    })
  },
  methods: {
    sijiChange (e) {
      if (e) {
        let json = this.sijiList.filter(item => item.id == e)
        this.$set(this.addForm, 'driverName', json[0].name)
        this.$set(this.addForm, 'driverPhone', json[0].mobile)
        this.$set(this.addForm, 'idNumber', json[0].identityNo)
        this.$set(this.addForm, 'rootTissueId', json[0].companyOrgId)
        this.$set(this.addForm, 'rootTissueCode', json[0].companyOrgCode)
        this.$set(this.addForm, 'rootTissueName', json[0].companyOrgName)
        this.$set(this.addForm, 'teamOrgId', json[0].teamOrgId)
        this.$set(this.addForm, 'teamOrgName', json[0].teamOrgName)
        this.$set(this.addForm, 'teamCode', json[0].teamOrgCode)
        this.$set(this.addForm, 'teamName', json[0].teamOrgName)
        this.$set(this.addForm, 'teamId', json[0].teamOrgId)
      }
    },
    carChange (e) {
      if (e) {
        let json = this.carList.filter(item => item.vhcNo == e)
        this.$set(this.addForm, 'vehicleId', json[0].id)
        this.$set(this.addForm, 'licensePlateColorName', json[0].noColourName)
        this.$set(this.addForm, 'trailerPlate', json[0].trailerNo)
        this.$set(this.addForm, 'vehicleTypeName', json[0].vhcTypeName)
        this.$set(this.addForm, 'vehicleTeamId', json[0].teamOrgId)
        this.$set(this.addForm, 'vehicleTeamCode', json[0].teamOrgCode)
        this.$set(this.addForm, 'vehicleTeamName', json[0].teamOrgName)
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.code == e)
        this.$set(this.addForm, 'teamName', json[0].name)
        this.$set(this.addForm, 'teamId', json[0].id)
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
        cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: json[0].id }).then(res => {
          this.loading = false
          this.carList = res
        })
        this.$set(this.addForm, 'driverId', null)
        this.$set(this.addForm, 'driverName', null)
        this.$set(this.addForm, 'driverPhone', null)
        this.$set(this.addForm, 'idNumber', null)
        this.$set(this.addForm, 'rootTissueId', null)
        this.$set(this.addForm, 'rootTissueCode', null)
        this.$set(this.addForm, 'rootTissueName', null)
        this.$set(this.addForm, 'vehicleId', null)
        this.$set(this.addForm, 'plateNumber', null)
        this.$set(this.addForm, 'licensePlateColorName', null)
        this.$set(this.addForm, 'vehicleTypeName', null)
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
}
</style>
